import { TabName, TabState, TabType } from 'components/TCDashboardTab/types';

export const defaultTabsConfig = [
  {
    keyName: 'DASHBOARD.TC.FILTER.NEWPEOPLE',
    name: TabName.NEW,
    type: TabType.LARGE,
    state: TabState.ACTIVE,
  },
  {
    keyName: 'DASHBOARD.TC.FILTER.FINISHINGACTIVITIES',
    name: TabName.FINISHING_PROGRAM,
    type: TabType.LARGE,
  },
  {
    keyName: 'DASHBOARD.TC.FILTER.PAUSEDACTIVITIES',
    name: TabName.DISENGAGED,
    type: TabType.LARGE,
  },
  {
    keyName: 'DASHBOARD.TC.FILTER.ACTIVITIESNOTSTARTED',
    name: TabName.NOT_INITIALIZED,
    type: TabType.LARGE,
  },
  {
    keyName: 'DASHBOARD.TC.FILTER.ACTIVITIESPROGRESS',
    name: TabName.ENGAGED,
    type: TabType.LARGE,
  },
  {
    keyName: 'DASHBOARD.TC.FILTER.WARNINGUSERSAMOUNT',
    name: TabName.WARNING,
    type: TabType.SMALL,
  },
  {
    keyName: 'DASHBOARD.TC.FILTER.UNLINKEDUSERSAMOUNT',
    name: TabName.NOT_VINCULATED,
    type: TabType.SMALL,
  },
];
